module.exports = __webpack_public_path__ + "static/media/great-things-take-time.952f24c6.svg";